import { lazy } from "react";
import { Theme } from "../data/style/Theme";
import DatePanel from "../components/Display/DatePanel";
import { MainText, MainTitle, scrollBar } from "../data/style/Style";

const Stack = lazy(() => import("@mui/material/Stack"));

const TERMS = [
  {
    title: "🎂 Eligibility",
    description:
      "You must be at least 16 years old to use the App. If you are under the age of majority, you must have permission from a parent or legal guardian.",
  },
  {
    title: "🩺 No Medical Advice",
    description:
      "The content provided in the App is for informational and general fitness purposes only. It is not medical advice. Always consult a physician or qualified health professional before beginning any fitness or nutrition program.",
  },
  {
    title: "📝 User Registration",
    description:
      "To access some features, you may be required to register for an account. You agree to provide accurate and complete information and to keep your login credentials secure. You are responsible for all activity under your account.",
  },
  {
    title: "©️ Intellectual Property",
    description:
      "All content on the App—including text, images, workouts, videos, designs, software, and logos—is owned by Grind Partner or its licensors and is protected by copyright, trademark, and other laws.",
    bullets: [
      "Copy, reproduce, modify, or distribute any part of the App or its content without our written permission",
      "Reverse-engineer, decompile, or extract source code",
      "Use the App or content for commercial purposes without authorization",
    ],
  },
  {
    title: "🚫 User Conduct",
    description: "You agree not to use the App:",
    bullets: [
      "For any unlawful or harmful activity",
      "To upload or transmit any malicious code or viruses",
      "To harass, threaten, or defame others",
    ],
  },
  {
    title: "🔚 Termination",
    description:
      "We may suspend or terminate your access to the App at any time, without notice, if we believe you violated these Terms.",
  },
  {
    title: "⚠️ Disclaimer of Warranties",
    description:
      "The App is provided “as is” and “as available” without warranties of any kind. We do not guarantee the App will be error-free or uninterrupted.",
  },
  {
    title: "⚖️ Limitation of Liability",
    description:
      "To the maximum extent permitted by law, Grind Partner and its owners are not liable for any injuries, damages, or losses resulting from your use of the App.",
  },
  {
    title: "🔒 Privacy",
    description:
      "Your use of the App is also governed by our Privacy Policy. Please review it to understand how we collect and use your information.",
  },
  {
    title: "🔄 Changes to Terms",
    description:
      "We may update these Terms at any time. Changes will be posted  on our website. Continued use of the App means you accept the new Terms.",
  },
  {
    title: "📧 Contact Us",
    description: "If you have any questions about these Terms, contact us at:",
    bullets: [process.env.REACT_APP_CONTACT_EMAIL],
  },
];

const Terms = () => {
  return (
    <Stack height={"100%"} gap={1} p={1}>
      <Stack height={"100%"} overflow={"auto"} gap={2} pr={1} sx={scrollBar}>
        <Stack ml={1} gap={2}>
          <MainTitle>Terms of use</MainTitle>
          <Stack alignSelf={"end"} direction={"row"} gap={3} pr={1}>
            <DatePanel label={"Effective Date"} date={"19/06/2025"} />
            <DatePanel label={"Last updated"} date={"19/06/2025"} />
          </Stack>
        </Stack>
        <Stack
          sx={{
            background: Theme.palette.card,
            border: 1,
            borderColor: Theme.palette.border,
            borderRadius: 4,
          }}
          p={1}
          gap={1}
        >
          <MainTitle>⚖️ agreement</MainTitle>
          <MainText>
            Welcome to Grind Partner. These Terms of Use (“Terms”) govern your
            access to and use of the Grind Partner application ("App") and any
            related services. By using the App, you agree to these Terms. If you
            do not agree, do not use the App.
          </MainText>
        </Stack>
        <Stack pb={3} gap={2}>
          {TERMS.map((item, index) => (
            <Stack
              key={index}
              gap={0.5}
              p={1}
              sx={{
                border: 1,
                borderRadius: 4,
                borderColor: Theme.palette.border,
                background: Theme.palette.card,
              }}
            >
              <MainTitle>{item.title}</MainTitle>
              <MainText>{item.description}</MainText>
              {item?.bullets?.map((bullet, index) => (
                <Stack key={index}>
                  <MainText>
                    <span
                      style={{
                        fontWeight: "bold",
                        color: Theme.palette.orange,
                      }}
                    >
                      •{" "}
                    </span>
                    {bullet}
                  </MainText>
                </Stack>
              ))}
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Terms;
